<template>
  <div>
    <div class="ifbox" :style="LiveStreamType == 1 ? 'height: 1015px;' : ''">
      <iframe id="iframeLive" ref="iframeLive" class="iframeLive" scrolling="no" allowfullscreen="true"
        webkitallowfullscreen="true" mozallowfullscreen="true" oallowfullscreen="true" msallowfullscreen="true"
        :src="LiveSrc"></iframe>
      <div class="timebox" v-show="time > 0">试看倒计时{{ time }}s | <a href="javascript:0"
          @click="toPcLogin('default')">登录</a>
      </div>
    </div>
    <div style="width:100%;height:0px;background-color: #eaf2fe;position: relative;">
      <div class="mobile">
        <el-popover placement="bottom-start" width="280" trigger="hover">
          <div class="mobbox">
            <div class="mobboxl">
              <img :src="mobUrl" alt="">
            </div>
            <div class="mobboxr">
              <p class="mobboxr1">扫码进入移动端观看页</p>
              <p class="mobboxr2">推荐使用微信扫一扫</p>
            </div>
          </div>
          <div slot="reference" class="mobbtn">
            <img src="../../assets/img/icon/mobile.png" alt="">
            <span>手机观看</span>
          </div>
        </el-popover>
      </div>
    </div>
    <div class="EC_width bodytop">
      <div class="guanggao" @click="toLink" v-show="lId == 845562">
        <img src="https://cgp-publicfile.oss-cn-beijing.aliyuncs.com/Images/Images/gp51920220519.png" alt="">
      </div>
      <div class="btitle display_center_ud">
        <img v-if="(menulist.length > 0)" src="../../assets/img/icon/live.png" alt="">
        <div v-for="(item, index) in menulist" :key="index">
          <span v-show="index != 0" style="margin:0 10px;">/</span>
          <span :style="showBoxId == index ? 'cursor: pointer;color:#0b8586' : 'cursor: pointer;'"
            @click="showBoxId = index">{{ item.name }}</span>
        </div>
      </div>
    </div>
    <div class="EC_width body display_column">
      <div class="bodyBox display_column" v-for="(item, index) in menulist" :key="index">
        <div class="bbox" v-if="showBoxId == index">
          <!-- 图文 -->
          <div class="tuwenbox" v-if="item.type == 2">
            <div v-if="item.liveDetailList.length > 0" v-html="item.liveDetailList[0].contents"></div>
          </div>
          <!-- 视频 -->
          <div class="wrap_content" v-else-if="item.type == 3">
            <swiper :options="swiperOption2">
              <swiper-slide v-for="(items, indexs) in item.liveDetailList" :key="indexs + 's'" @click="breadclk(items)">
                <div class="video-card">
                  <img :src="items.coverPictureUrl" class="cont_img" alt="">
                  <img src="../../assets/img/icon/bofang3.png" class="btn" @click="toShipin(items)" alt="">
                  <p class="title ng-star-inserted">
                    {{ items.title }}
                  </p>
                </div>
              </swiper-slide>
            </swiper>
            <div class="prevbutton2 el-icon-arrow-left"></div>
            <div class="nextbutton2 el-icon-arrow-right"></div>
          </div>
          <!-- 超级链接 -->
          <div class="wrap_content linkBox" v-else-if="item.type == 4">
            <swiper :options="swiperOption1">
              <swiper-slide v-for="(items, indexs) in item.liveDetailList" :key="indexs + 's'" @click="linkclk(items)">
                <div class="display_center_lr" style="width:100%" v-if="items.coverPictureUrl != ''">
                  <img :src="items.coverPictureUrl" style="cursor: pointer" width="250px" height="300px;" />
                </div>
              </swiper-slide>
            </swiper>
            <div class="prevbutton1 el-icon-arrow-left"></div>
            <div class="nextbutton1 el-icon-arrow-right"></div>
          </div>
        </div>
      </div>
      <el-dialog :visible.sync="isShipin" :title="shipinTitle" :before-close="shipinClose" width="700px">
        <div id="shipin"></div>
      </el-dialog>
    </div>
    <footer_index></footer_index>
  </div>
</template>

<script>
import footer_index from '../../components/liveFooter';
import format from '@/assets/unit/unit.js';
import Player from 'xgplayer';
export default {
  name: "muduLive",
  components: {
    footer_index
  },
  data() {
    return {
      lId: 0, //直播id
      LiveSrc: '',
      menulist: [],
      menutype: 0,
      linkList: [],
      breadList: [],
      content: '',
      AuthorId: 0,
      swiperOption2: {
        slidesPerView: 4,
        slidesPerGroup: 1,
        spaceBetween: 10,
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.nextbutton2',
          prevEl: '.prevbutton2',
          disabledClass: 'my-button-disabled'
        }
      },
      swiperOption1: {
        slidesPerView: 4,
        slidesPerGroup: 1,
        spaceBetween: 10,
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.nextbutton1',
          prevEl: '.prevbutton1',
          disabledClass: 'my-button-disabled'
        }
      },
      isShipin: false,
      shipinTitle: '',
      player: null,
      mtgId: 0,
      liveType: 1,
      mobUrl: '',
      LiveStreamType: 0,
      qid: 0,
      showBoxId: 0,
      authType: 1,
      siteType: 1,
      time: 0,
      bgimg: '',
      wcUserId: 0,
      isSign: false
    }
  },
  methods: {

    /** @description 跳转到微信登录页面 */
    towxLogin() {
      let callback = encodeURIComponent(window.location.href);
      this.$router.push({
        name: 'wxlogin',
        query: {
          url: callback
        }
      })
    },
    /**  
     * @description 去掉url指定参数 
     * @param {string}  url url地址
     * @param {string}  name 去掉参数的名称
     */
    delUrlData(url, name) {
      var urlparts = url.split('?');
      if (urlparts.length >= 2) {
        //参数名前缀
        var prefix = encodeURIComponent(name) + '=';
        var pars = urlparts[1].split(/[&;]/g);

        //循环查找匹配参数
        for (var i = pars.length; i-- > 0;) {
          if (pars[i].lastIndexOf(prefix, 0) !== -1) {
            //存在则删除
            pars.splice(i, 1);
          }
        }
        return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
      }
      return url;
    },
    /** 
     * @description: 微信登录
     * @param {string} wechatcode 微信获取的code
     */
    wechatlogin(wechatcode) {
      this.httphelper
        .post('/api/CGpUserApi/WeChatUserLoginNew', {
          code: wechatcode,
          id: 0,
          LoginType: 1
        })
        .then(res => {
          if (res.data.code == 200) {
            var userinfo = {
              userid: res.data.data.id,
              type: 1
            };
          } else if (res.data.code == 235) {
            var userinfo = {
              userid: res.data.data.id,
              type: 2
            };
          } else if (res.data.code == 500) {
            var userinfo = {
              userid: 0,
              type: 3
            };
          }
          this.$cookies.set('meetingkey', JSON.stringify(userinfo));
          let info = this.$cookies.get('meetingkey')
          if (info) {
            window.location.href = this.delUrlData(this.delUrlData(window.location.href, 'code'), 'state')
          }

        });
    },
    /** @description 获取直播配置 */
    getLiveRes() {
      if (this.$route.query.id) this.lId = this.$route.query.id

      this.httphelper.post('/api/LiveApi/GetLiveRegistSetById', {
        id: this.lId,
        liveType: this.liveType
      }).then(res => {
        if (res.data.code == 200) {
          //判断授权方式:this.authType (1:微信登录 2:手机号登录 3:免登录)
          this.authType = res.data.data.authType
          this.siteType = res.data.data.siteType
          this.isSign = res.data.data.isSign
          // this.authType==1 微信登录
          if (this.authType == 1) {
            let info = this.$cookies.get('meetingkey')
            if (info) {
              if (info.type == 1) {
                this.AuthorId = Number(info.userid)
              } else if (info.type == 2) {
                // this.AuthorId = Number(info.userid)
                this.wcUserId = Number(info.userid);
              }
              this.toLive()
            } else if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query, 'code')) {
              this.wechatlogin(this.$route.query.code)
            } else {
              this.towxLogin()
            }
          }
          // this.authType==2 手机号登录
          else if (this.authType == 2) {
            this.$cookies.remove('meetingkey');
            if (this.$cookies.isKey('token_chinagp') && !Object.prototype.hasOwnProperty.call(this.$route.query, 'tokenkey')) {
              var _tokenkey = this.$cookies.get('token_chinagp');
              this.httphelper
                .post('/api/LoginApi/CheckToken', {
                  tokenKey: _tokenkey
                })
                .then(res => {
                  if (res.data.code == 200) {
                    if (this.isMobile()) {
                      window.location.href = window.location.href.replace(/muduLive/, "muduLiveMobile")
                    } else {
                      this.$cookies.set('token_chinagp', _tokenkey);
                      //访问直播页面
                      this.AuthorId = res.data.data.id;
                      this.toLive();
                    }
                  } else {
                    this.$alert('请先登录', '提示', {
                      confirmButtonText: '确定', callback: action => {
                        this.toPcLogin('default')
                      }
                    });
                  }
                });
            }
            else if (Object.keys(this.$route.query).length > 0 && (Object.prototype.hasOwnProperty.call(this.$route.query, 'tokenkey') || Object.prototype.hasOwnProperty.call(this.$route.query, 'token'))) {
              let tok = this.$route.query.tokenkey || this.$route.query.token
              this.httphelper
                .post('/api/LoginApi/CheckToken', {
                  tokenKey: tok
                })
                .then(res => {
                  if (res.data.code == 200) {
                    if (this.isMobile()) {
                      window.location.href = window.location.href.replace(/muduLive/, "muduLiveMobile")
                    } else {
                      this.$cookies.set('token_chinagp', tok);
                      let curl = this.delUrlData(window.location.href, "tokenkey");
                      window.location.href = curl;
                      //访问直播页面
                      this.AuthorId = res.data.data.id;
                      this.toLive();
                    }
                  } else {
                    this.$alert('请先登录', '提示', {
                      confirmButtonText: '确定', callback: action => {
                        this.toPcLogin('default')
                      }
                    });
                  }
                });
            }
            else {
              if (this.isMobile()) {
                window.location.href = window.location.href.replace(/muduLive/, "muduLiveMobile")
              } else {
                this.time = res.data.data.tryTimes * 60
                if (this.time > 0) {
                  this.getMeetingInfo()
                  //获取授权地址
                  this.GetUserAuth();
                  //菜单绑定
                  this.getLiveMenuById();
                  this.getQRCode();
                }
                var test2 = setInterval(() => {
                  this.time--
                  if (this.time <= 0) {
                    clearInterval(test2);
                    this.LiveSrc = this.bgimg
                    this.$alert(res.data.data.tryTimes == 0 ? '请先登录后观看' : '试看结束，请先登录后观看', '提示', {
                      confirmButtonText: '确定', callback: action => {
                        this.toPcLogin('default')
                      }
                    });
                  }
                }, 1000)
              }
            }
          }
          // this.authType == 3 免登录
          else if (this.authType == 3) {
            this.getMeetingInfo()
            //获取授权地址
            this.GetUserAuth();
            //菜单绑定
            this.getLiveMenuById();
            this.getQRCode();
          }
        }
      });
    },
    /** @description 时间格式化  */
    formatTime(datatime, timeformat) {
      return format(datatime, timeformat);
    },
    /** @description 排序 */
    sortKey(array, key) {
      return array.sort(function (a, b) {
        var x = a[key];
        var y = b[key];
        return x < y ? -1 : x > y ? 1 : 0;
      });
    },
    /** @description 获取目睹授权地址 */
    GetUserAuth() {
      let _this = this;
      _this.httphelper.post('/api/LiveApi/GetUserAuth', {
        id: parseInt(this.lId),
        assign_id: this.AuthorId.toString(),
        expire: 7200,
        tourl: '',
        wcUserId: this.wcUserId
      }).then(res => {
        if (res.data.code == 200) {
          let data = res.data.data;
          _this.LiveSrc = data//.replace('http://','https://');
        }
      });
    },
    /** @description 获取直播间菜单 */
    getLiveMenuById() {
      let _this = this;
      _this.httphelper.post('/api/LiveApi/getLiveMenuById', {
        Id: this.lId,
        LiveType: 1
      }).then(res => {
        if (res.data.code == 200) {
          _this.menulist = []
          let data = res.data.data;
          if (data != null) {
            for (let i = 0; i < data.length; i++) {
              if (data[i].type != 5) {
                _this.menulist.push(data[i])
              }
            }
          }
        }
      });
    },
    /** @description 获取直播间名称和背景图 */
    getMeetingInfo() {
      let _this = this;
      _this.httphelper.post('/api/LiveApi/GetMuduLiveById', {
        id: _this.lId,
        liveType: 0
      }).then(res => {
        if (res.data.code == 200) {
          document.title = res.data.data.name || '全科医学网'
          this.bgimg = res.data.data.live_img
        }
      });
    },
    /** @description 超级链接跳转 */
    linkclk(item) {
      window.open(item.hyperlinks);
    },
    toLink() {
      window.open(this.httphelper.IsDebugGP519());
    },
    /** @description 弹出视频 */
    toShipin(item) {
      this.shipinTitle = item.title
      this.isShipin = true
      var test1 = setTimeout(() => {
        this.player = new Player({
          id: 'shipin',
          url: item.resUrl,
          autoplay: true,
          playsinline: true,
          width: '100%',
          height: 'auto'
        });
        clearTimeout(test1);
      }, 100);
    },
    /** @description 关闭弹出视频 */
    shipinClose() {
      if (this.player != null) {
        this.player.destroy();
        this.player = null;
      }
      this.isShipin = false
    },
    /** @description 判断是手机还是pc */
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return flag;
    },
    /** @description 会议——检测是否登录，如果没有登录跳转到相应的地址*/
    regclick() {
      if (this.$cookies.isKey('token_chinagp')) {
        var _tokenkey = this.$cookies.get('token_chinagp');
        this.httphelper
          .post('/api/LoginApi/CheckToken', {
            tokenKey: _tokenkey
          })
          .then(res => {
            if (res.data.code == 200) {
              if (res.data.data.mobile == '' || res.data.data == null) {
                this.Defconfirm();
                return;
              }
              window.open('https://meeting.gp519.com/reg?mtgid=' + this.mtgId, '_blank');
            } else {
              let callback = encodeURIComponent('https://meeting.gp519.com/reg?mtgid=' + this.mtgId);
              this.toPcLogin(callback)

            }
          });
      } else if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query,
        'tokenkey')) {
        this.httphelper
          .post('/api/LoginApi/CheckToken', {
            tokenKey: this.$route.query.tokenkey
          })
          .then(res => {
            if (res.data.code == 200) {
              if (res.data.data.mobile == '' || res.data.data == null) {
                this.Defconfirm();
                return;
              }
              window.open('https://meeting.gp519.com/reg?mtgid=' + this.mtgId, '_blank');
            } else {
              let callback = encodeURIComponent('https://meeting.gp519.com/reg?mtgid=' + this.mtgId);
              this.toPcLogin(callback)
            }
          });
      } else {
        var hrefurl = '';
        hrefurl = 'https://meeting.gp519.com/reg?mtgid=' + this.mtgId;
        let callback = encodeURIComponent(hrefurl);
        this.toPcLogin(callback)
      }
    },
    /** @description 会议报名提示必须完善个人信息 */
    Defconfirm() {
      this.$confirm('会议报名必须先完善个人信息, 是否前往用户中心完善个人信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({ name: 'userInfor' });
      });
    },
    /** @description 跳转到登录页面 */
    toPcLogin(cback) {
      let callback = cback
      if (cback == 'default') callback = encodeURIComponent(window.location.href);
      if (this.siteType == 2) {
        window.location.href = window.location.origin + '/loginIndex/login?callback=' + callback + '&type=2';
      } else {
        window.location.href = window.location.origin + '/loginIndex/login?callback=' + callback;
      }
    },
    /** @description 进入直播间 */
    toLive() {
      if (this.$route.query.LiveStreamType == 1) {
        this.LiveStreamType = 1
      }
      let _this = this
      _this.lId = this.$route.query.id
      if (_this.$route.query.mid != '' && _this.$route.query.mid != null && _this.$route.query.mid != '0') {
        _this.mtgId = _this.$route.query.mid;
      } else {
        _this.mtgId = 0
      }
      if (_this.isSign) {
        //验证是否需要报名
        _this.httphelper.post('/api/LiveApi/GetLiveRegistSet', {
          liveId: _this.lId.toString(),
          liveType: parseInt(_this.liveType),
          mtgId: parseInt(_this.mtgId),
          userId: parseInt(_this.AuthorId)
        }).then(res => {
          if (res.data.code != 200) {
            //请先报名
            this.$alert(res.data.msg, '提示', {
              confirmButtonText: '确定', callback: action => {
                _this.regclick();
              }
            });
          } else {
            _this.CheckIsQuestionnaire();
          }
        });
      } else {
        _this.CheckIsQuestionnaire();
      }
    },
    /** @description 验证是否需要问卷 */
    CheckIsQuestionnaire() {

      this.httphelper.get('/api/LiveApi/CheckIsQuestionnaire?mid=' + this.mtgId + '&liveid=' + this.lId + '&livetype=' + parseInt(this.liveType)).then(res => {
        // 不需要填写问卷
        if (res.code == 200) {
          this.getMeetingInfo()
          //获取授权地址
          this.GetUserAuth();
          //菜单绑定
          this.getLiveMenuById();
          this.getQRCode();
        }
        // 需要填写问卷
        else if (res.code == 20) {
          this.qid = res.data.id
          let info = this.$cookies.get('meetingkey');
          let userid = this.AuthorId;
          if (info) {
            if (info.type == 1) {
              userid = Number(info.userid)
            } else if (info.type == 2) {
              userid = Number(info.userid);
            }
          }
          //验证当前用户是否填写过问卷
          this.httphelper.get('/api/QuestionnaireApi/CheckIsFeedback?qid=' + res.data.id + '&userid=' + userid).then(res => {
            // 填写过
            if (res.code == 200) {
              this.getMeetingInfo()
              //获取授权地址
              this.GetUserAuth();
              //菜单绑定
              this.getLiveMenuById();
              this.getQRCode();
            } else {
              //跳转调查问卷 
              // this.$alert('请先填写调查问题', '提示', {
              //   confirmButtonText: '确定', callback: action => {

              //   }
              // });
              let callback = encodeURIComponent(window.location.href);
              this.$router.push({
                path: '/question?',
                query: {
                  qid: this.qid,
                  callback: callback,
                  ulogintype: this.authType
                },
              })
            }
          });
        } else {
          this.$message({
            message: res.msg,
            type: 'warning'
          });
        }

      });
    },
    /** 获取手机观看地址 */
    getQRCode() {
      this.httphelper.post('/api/QRCoder/GetQRCode', {
        url: window.location.href.replace(/muduLive/, "muduLiveMobile")
      })
        .then(res => {
          if (res.data.code == 200) {
            this.mobUrl = 'data:image/png;base64,' + res.data.data
          }
        })
    },
  },
  created() {
    if (this.isMobile()) {
      window.location.href = window.location.href.replace(/muduLive/, "muduLiveMobile")
    } else {
      this.getLiveRes()
    }
  }
}
</script>
 

<style scoped>
.ifbox {
  width: 100%;
  height: 808px;
  display: flex;
  justify-content: center;
  /* background-repeat: center; */
  /* background-size: 1925px 1100px; */
  /* background-image: url('../../assets/img/livebg2.png'); */
  background-color: #eaf2fe;
  /* background-image: linear-gradient(to bottom, #e7f0fe, #f4f7fd, #f4f7fd); */
  /* background-position: 50% 0; */
  overflow: hidden;
  position: relative;
}

.timebox {
  position: absolute;
  top: 60px;
  right: 50%;
  margin-right: -600px;
  z-index: 10000;
  display: inline-block;
  height: 22px;
  line-height: 12px;
  font-size: 12px;
  padding: 5px;
  box-sizing: border-box;
  background-color: rgb(206, 35, 35);
  color: #fff;
  border-radius: 15px;
}

.timebox a {
  color: #fff;
  line-height: 12px;
}

.ifRight {
  height: 100%;
  width: 500px;
  background-color: #eaf2fe;
  position: absolute;
  left: 50%;
  top: 0;
  margin-left: 620px;
}

.ifLeft {
  height: 100%;
  width: 500px;
  background-color: #eaf2fe;
  position: absolute;
  right: 50%;
  top: 0;
  margin-right: 620px;
}

.ifTop {
  width: 100%;
  height: 20px;
  background-color: #eaf2fe;
  position: absolute;
  top: 0;
}

.ifBot {
  width: 100%;
  height: 20px;
  background-color: #eaf2fe;
  position: absolute;
  top: 661px;
}

.ifMid {
  height: 100%;
  width: 8px;
  background-color: #eaf2fe;
  position: absolute;
  left: 50%;
  top: 0;
  margin-left: 260px;
}

.iframeLive {
  min-width: 1378px;
  width: 1378px;
  height: 10000px;
  border: none;
  margin: 0 auto;
  overflow: hidden;
  /* margin-top: -140px; */
  margin-top: 0;
}

.mobile {
  position: absolute;
  top: -38px;
  right: 50%;
  margin-right: 515px;
}

.mobbtn {
  height: 20px;
  padding: 0 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
  color: rgb(94, 94, 94);
}

.mobbtn img {
  margin-right: 5px;
}

.mobbtn :hover {
  color: #448aff;
}

.mobbox {
  display: flex;
  align-items: center;
}

.mobboxl {
  width: 100px;
  height: 100px;
  margin-right: 10px;
}

.mobboxr {
  text-align: center;
}

.mobboxr1 {
  font-size: 16px;
  color: #448aff;
}

.mobboxr2 {
  color: rgb(94, 94, 94);
}

.btitle {
  height: 60px;
  font-weight: 800;
  font-size: 18px;
}

.btitle img {
  margin-right: 20px;
}

.body {
  padding: 0px 0 70px;
}

.bodytop {
  padding: 30px 0 0;
}

.bodytop .guanggao {
  width: 1240px;
  height: 40px;
  /* background-color: #666; */
  margin-bottom: 20px;
  cursor: pointer;
}

.bodytop .guanggao img {
  height: 40px;
}

.tuwenbox {
  padding: 20px 0;
}

.linkBox {
  width: 1000px;
}

.nextbutton1,
.prevbutton1,
.nextbutton2,
.prevbutton2 {
  display: inline-block;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  box-sizing: border-box;
  border-radius: 30px;
  background: #0b8586;
  color: #fff;
  position: absolute;
  top: 42%;
  z-index: 10;
  cursor: pointer;
  outline: none;
}

.nextbutton1,
.nextbutton2 {
  right: -30px;
  left: auto;
}

.prevbutton1,
.prevbutton2 {
  right: auto;
  left: -30px;
}

.wrap_content {
  position: relative;
  padding: 30px 0;
}

.my-button-disabled {
  background: #ddd;
  color: #999;
}

.video-card {
  width: 280px;
  height: 210px;
  padding: 10px 15px;
  background-color: #f6f4fa;
  box-sizing: border-box;
  position: relative;
}

.video-card .cont_img {
  width: 250px;
  height: 140px;
  border-radius: 5px 5px 0 0;
}

.video-card .btn {
  position: absolute;
  top: 65px;
  left: 130px;
  cursor: pointer;
}

.video-card p {
  height: 50px;
  border-radius: 0 0 5px 5px;
  background-color: #fff;
  margin-top: -3px;
  line-height: 20px;
  font-size: 14px;
  padding: 6px 5px 10px;
  box-sizing: border-box;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

/* .video-card .title {
    overflow: hidden;
} */
</style>

